export default {
  login: {
    clientIdPlaceholder: "ClientID",
    usernamePlaceholder: "ユーザーID",
    passwordPlaceholder: "パスワード",
    loginButton: "ログイン",
    forgotPassword: "パスワードを忘れた方は",
    forgotPasswordLink: "こちら",
    errorMessage: "ログイン情報が正しくありません。",
    note: "パスワードをお忘れの方は、管理者までお問い合わせください。",
  },
  formReset: {
    initPassword: {
      textHeader: "パスワードの設定",
      textSubmit: "パスワードを設定",
      textSuccess: "パスワードを設定しました。",
    },
    changePassword: {
      textHeader: "パスワードの再設定",
      textSubmit: "パスワードを再設定",
      textSuccess: "パスワード変更出来ました。",
    },
    successMessage: "パスワード変更出来ました。",
    newPasswordPrompt: "新しいパスワードを入力してください",
    passwordMismatchError: "パスワードが一致しません。",
    newPasswordPlaceholder: "新しいパスワード",
    confirmPasswordPlaceholder: "新しいパスワード（確認用）",
  },
  forgetPassword: {
    emailCheck: "メールをご確認ください。",
    prefixEmailSend: "パスワード再設定メールを",
    suffixEmailSend: "宛てにお送りしました。",
    followInstructions: "お送りしたメールの内容に従ってパスワードを再設定ください。",
    resetPassword: "パスワード再発行",
    resetPasswordInstructions:
      "パスワードを再発行します。\n再発行パスワードは登録メールアドレスに送信されます。\nメールアドレス未登録の方は管理者に連絡して下さい。",
    userNotFound: "このユーザーが存在しません。",
    forgotPasswordLink: "ログイン画面に戻る",
    emailPlaceholder: "メールアドレス",
  },
}
